<template>
  <div>
    <div>
      <div style="background-color: #fff;">
        <el-radio-group v-model="radio" size="small" @change="handleClickradio" >
          <el-radio-button label="1">客户库存</el-radio-button>
          <el-radio-button label="2">仓位库存</el-radio-button>
        </el-radio-group>
      </div>
      <div v-show="radio==1">
        <!-- 查询条件 -->
        <div ref="searchBoxKH" class="" style="background-color: #fff;padding: 10px 0 0 0;">
          <el-form :inline="true" :model="formDataKH" class="demo-form-inline" ref="formDataKH" label-width="90px" size="mini">
            <div class="formItemBox">
            <el-form-item label="仓库名称:">
              <el-select filterable clearable placeholder="请选择仓库名称" v-model="CKName" multiple @change="clickCK()">
                <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName"
                  :value="item.relTenantCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="一级货主:">
              <el-input v-model="formDataKH.primaryCustomerName" placeholder="请选择货主" filterable clearable></el-input>
            </el-form-item>
            <el-form-item label="二级货主:">
              <el-input v-model="formDataKH.customerName" placeholder="请选择货主" filterable clearable></el-input>
            </el-form-item>
            <el-form-item label="货物类型:">
              <el-select v-model="productType" placeholder="请选择货物类型" filterable clearable>
                <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
                  :value="item.productType"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产地:">
              <el-select v-model="steelMillName" placeholder="请选择产地" filterable clearable>
                <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规格:">
              <el-select v-model="specification" placeholder="请选择规格" filterable clearable>
                <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="材质:">
              <el-select v-model="model" placeholder="请选择材质" filterable clearable>
                <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="件数:">
              <el-select v-model="formDataKH.number" placeholder="请选择件数" filterable clearable>
                <el-option v-for="(item, index) in numberOptions" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            </div>
            <el-form-item style="padding-left: 10px;">
              <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZP00DB004" v-if="btnFlg[3]">查询
              </el-button>
              <el-button type="primary" size="mini" @click="chongzhi" btnCode="00ZP00DB005" v-if="btnFlg[4]">重置
              </el-button>
              <el-button type="primary" size="mini" @click="daochu" btnCode="00ZP00DB006" v-if="btnFlg[5]">导出
              </el-button>
              <el-button type="primary" size="mini" @click="MBdaochu" btnCode="00ZP00DB00B" v-if="btnFlg[10]">模板导出
              </el-button>
            </el-form-item>
          </el-form>
          <div ref="searchBox2" style="margin-bottom:8px;margin-left:10px;padding-bottom: 5px;">
            <span>
              总吨数:
              <span style="color: red">{{Number(totalAllWeight)}}</span> &nbsp;吨
            </span>
            <span style="margin-left: 15px">
              总件数:
              <span style="color: red">{{ totalNumber }}</span> &nbsp;件
            </span>
          </div>
        </div>
        <!-- 表格 -->
        <div :style="{ height: h }">
          <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData"
            style="width: 100%" class="elTab" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            highlight-current-row>
            <el-table-column fixed type="index" align="center" label="序号" width="60"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" width="250">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" align="center"
              width="220"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="customerName" label="二级货主" align="center" width="220">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
              width="120"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="100">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="100">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="90">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120" align="center">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重(吨)" align="center">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="过磅净重（吨）" width="120"
              align="center">
            </el-table-column>
          </el-table>
        </div>
        <div class="pags" style="text-align: right">
          <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo"
            :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]"
            layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 仓位库存 -->
      <div v-show="radio==2">
        <!--查询条件-->
        <div ref="searchBoxCW" class="" style="background-color: #fff;padding: 10px 0 0 0;">
          <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="90px" size="mini">
            <div class="formItemBox">
            <el-form-item label="仓库名称:">
              <el-select filterable clearable placeholder="请选择仓库名称" v-model="CKName" multiple @change="clickCK()">
                <el-option v-for="(item, index) in CKData" :key="index" :label="item.relTenantName"
                  :value="item.relTenantCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="货物类型:">
              <el-select v-model="productType" clearable placeholder="请选择" filterable>
                <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
                  :value="item.productType">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产地:">
              <el-select v-model="steelMillName" clearable placeholder="请选择" filterable>
                <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="规格:">
              <el-select v-model="specification" clearable placeholder="请选择" filterable>
                <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="材质:">
              <el-select v-model="model" clearable placeholder="请选择" filterable>
                <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="件数:">
              <el-select v-model="searchFrom.number" clearable placeholder="请选择">
                <el-option v-for="(item, index) in numberOptions" :key="index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            </div>
            <el-form-item style="margin-top:7px;padding-left: 10px;">
              <el-button type="primary" @click="searchClick" btnCode="00ZP00DB007" v-if="btnFlg[6]">查询</el-button>
              <el-button type="primary" @click="chongZhiClick" btnCode="00ZP00DB008" v-if="btnFlg[7]">重置</el-button>
              <el-button type="primary" @click="exportClick" btnCode="00ZP00DB009" v-if="btnFlg[8]">导出</el-button>
            </el-form-item>
            <div style="margin:0 0 0 10px;display: flex;padding-bottom: 10px;">
              <div style="display: flex;">
                <div>总吨数：</div>
                <div style="color:red;">{{Number(totalAllWeight)}}</div>&nbsp;&nbsp;吨
              </div>
              <div style="margin-left:20px;display: flex;">
                <div>总件数：</div>
                <div style="color:red;">{{totalNumber}}</div>&nbsp;&nbsp;件
              </div>
            </div>
          </el-form>
        </div>
        <!--  表格 -->
        <div class="table" :style="{ height: H }">
          <el-table :data="tableList" ref="tableRef" border bordersize="mini" height="100%"
            style="width: 100%; margin-top: 10px" center :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
            :header-row-style="{ height: '45px' }" :row-style="{ height: '35px' }" highlight-current-row>
            <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="organizationName" label="仓库名称" width="250">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center" width="">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" align="center"
              width=""></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center" width="90">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center" width="120">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center" width="100">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center" width="80">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center" width="">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center" width="">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="过磅净重（吨）" align="center"
              width="">
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="avgWeight" label="平均重量（吨）" align="center" width="">
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 10,25,50,100-->
        <div style="text-align: right">
          <el-pagination background @size-change="handleSizeChangeCW" @current-change="handleCurrentChangeCW"
            :current-page="pageNo" :page-sizes="[10,20,30,40,50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="totalCW">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="请选择" :visible.sync="DialogVisible" :close-on-click-modal="false" @close="BHQx" width="40%" center>
      <div style="text-align:center;margin:20px 0 0 0">
        <span>导出客户：</span>
        <el-radio-group v-model="HZradio">
          <el-radio :label="1">一级货主</el-radio>
          <el-radio :label="2">二级货主</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BHQx">取 消</el-button>
        <el-button type="primary" @click="BHOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  JfgetStockCustomerList,
  JfgetStockCustomerWN,
  findUserTenantRelList,
  getVirtualBalingList, // 货物类型、产地、规格、材质、长度、件数级联查询
  JfgetStockWarehouseList,
  JfgetStockWarehouseWN,
  exTemplateStockCustomerList
} from '@/api/wms-stock'
import DonMessage from '@/utils/message'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  getBtn
} from '@/utils/getButton'
export default {
  name: 'JCRecord',
  data () {
    return {
      radio: '1',
      formDataKH: {
        primaryCustomerName: '',
        customerName: '',
        number: ''
      },
      productType: '',
      steelMillName: '',
      specification: '',
      model: '',
      productTypeData: [],
      steelMillNameData: [],
      specificationData: [],
      modelData: [],
      numberOptions: [{
        value: '',
        label: '全部'
      }, {
        value: '0',
        label: '0'
      }, {
        value: '-1',
        label: '不为0'
      }],
      totalAllWeight: 0,
      totalNumber: 0,
      h: '500px',
      H: '500px',
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      pageNo: 1,
      pageSize: 20,
      total: 0,
      totalCW: 0,
      tableData: [],
      turnGoodsTableList: [],
      turnMark: false,
      turnLoading: false,
      residue: 0,
      changeAllWeight: 0,
      daoruMark: false,
      selectListId: [],
      selectList: [],
      trunTitle: '转货申请',
      turnZhuanhuo: false,
      trunFlag: 'zhuanhuo',
      ZhuanhuoLoading: false,
      btnArr: [
        '00ZP00DB001',
        '00ZP00DB002',
        '00ZP00DB003',
        '00ZP00DB004',
        '00ZP00DB005',
        '00ZP00DB006',
        '00ZP00DB007',
        '00ZP00DB008',
        '00ZP00DB009',
        '00ZP00DB00A',
        '00ZP00DB00B'
      ],
      btnFlg: [],
      xuanzhongArr: null,
      ReminderVisible: false,
      message: '',
      isReminder: 0,
      CKName: [],
      CKData: [],
      searchFrom: {
        number: ''
      },
      tableList: [],
      HZradio: 2,
      DialogVisible: false
    }
  },
  methods: {
    // 仓库改变
    clickCK () {
      this.getVirtualBalingList()
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.wmsStockName + '/stockThreadExp/exportStockWarehouseList', {
          ...this.searchFrom,
          organizationIds: this.CKName.join(','),
          organizationFlag: 1,
          productType: this.productType,
          steelMillName: this.steelMillName,
          specification: this.specification,
          model: this.model
        },
        '仓位库存信息表'
      )
    },
    // 点击查询按钮
    searchClick () {
      this.JfgetStockWarehouseLists()
    },
    // 点击重置
    chongZhiClick () {
      this.model = ''
      this.searchFrom.warehouseId = ''
      this.productType = ''
      this.steelMillName = ''
      this.specification = ''
      this.searchFrom.number = ''
      this.CKName = []
      this.getVirtualBalingList()
      this.JfgetStockWarehouseLists()
    },
    // 每页条数
    handleSizeChangeCW (val) {
      this.pageSize = val
      this.JfgetStockWarehouseLists()
    },
    // 当前页
    handleCurrentChangeCW (val) {
      this.pageNo = val
      this.JfgetStockWarehouseLists()
    },
    JfgetStockWarehouseWNs () {
      JfgetStockWarehouseWN({
        pageNo: this.searchFrom.pageNo,
        pageSize: this.searchFrom.pageSize,
        model: this.model,
        warehouseId: this.searchFrom.warehouseId,
        productType: this.productType,
        steelMillName: this.steelMillName,
        specification: this.specification,
        number: this.searchFrom.number,
        organizationIds: this.CKName.join(','),
        organizationFlag: 1
      })
        .then(res => {
          console.log(res)
          // this.totalAllWeight = res.totalWeight
          this.totalAllWeight = parseFloat(res.totalWeight.toFixed(6))

          this.totalNumber = res.totalNumber
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 列表查询
    JfgetStockWarehouseLists () {
      JfgetStockWarehouseList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        model: this.model,
        warehouseId: this.searchFrom.warehouseId,
        productType: this.productType,
        steelMillName: this.steelMillName,
        specification: this.specification,
        number: this.searchFrom.number,
        organizationIds: this.CKName.join(','),
        organizationFlag: 1
      })
        .then(res => {
          console.log(res)
          this.JfgetStockWarehouseWNs()
          this.tableList = res.list
          this.totalCW = res.total
          this.tableList.forEach(item => {
            item.allWeight = parseFloat(item.allWeight.toFixed(6))
            item.weight = parseFloat(item.weight.toFixed(6))
            item.avgWeight = parseFloat(item.avgWeight.toFixed(6))
          })
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    /// //////////
    handleClickradio () {
      if (this.radio == 1) {
        this.chongzhi()
      } else {
        this.chongZhiClick()
        let H = this.$refs.searchBoxCW.offsetHeight
        let pHJC = document.documentElement.clientHeight
        this.H = pHJC - H - 233 + 'px'
      }
    },
    // 仓库名称
    findUserTenantRelList () {
      findUserTenantRelList({
        userCode: window.localStorage.getItem('userCode'),
        tenantCode: window.localStorage.getItem('tenantCode')
      })
        .then(res => {
          console.log(res)
          this.CKData = res
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 总数
    JfgetStockCustomerWNs () {
      JfgetStockCustomerWN({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        primaryCustomerName: this.formDataKH.primaryCustomerName,
        customerName: this.formDataKH.customerName,
        productType: this.productType,
        steelMillName: this.steelMillName,
        specification: this.specification,
        model: this.model,
        number: this.formDataKH.number,
        organizationIds: this.CKName.join(','),
        organizationFlag: 1
      })
        .then(res => {
          // this.totalAllWeight = res.totalWeight
          this.totalAllWeight = parseFloat(res.totalWeight.toFixed(6))

          this.totalNumber = res.totalNumber
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 列表查询
    JfgetStockCustomerLists () {
      JfgetStockCustomerList({
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        primaryCustomerName: this.formDataKH.primaryCustomerName,
        customerName: this.formDataKH.customerName,
        productType: this.productType,
        steelMillName: this.steelMillName,
        specification: this.specification,
        model: this.model,
        number: this.formDataKH.number,
        organizationIds: this.CKName.join(','),
        organizationFlag: 1
      })
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.turnGoodsTableList.forEach(item => {
            this.tableData.forEach((item1, index) => {
              item1.allWeight = parseFloat(item1.allWeight.toFixed(6))
              item1.weight = parseFloat(item1.weight.toFixed(6))
              if (!item1.isYuanZhuanFlag) {
                let a = item.stockCustomerId == item1.stockCustomerId
                item1.isYuanZhuanFlag = a
              }
            })
          })
          this.JfgetStockCustomerWNs()
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxun () {
      this.JfgetStockCustomerLists()
    },
    chongzhi () {
      this.formDataKH = {}
      this.CKName = []
      this.productType = ''
      this.steelMillName = ''
      this.specification = ''
      this.model = ''
      this.chaxun()
      this.getVirtualBalingList()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.chaxun()
    },
    // 导出
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/stockThreadExp/exportStockCustomerList', {
          ...this.formDataKH,
          organizationIds: this.CKName.join(','),
          organizationFlag: 1,
          productType: this.productType,
          steelMillName: this.steelMillName,
          specification: this.specification,
          model: this.model
        },
        '客户库存信息表'
      )
    },
    MBdaochu () {
      this.DialogVisible = true
    },
    BHOk () {
      let arr = []
      this.CKData.map(item => {
        this.CKName.map(i => {
          if (i == item.relTenantCode) {
            arr.push(item.relTenantName)
          }
        })
      })
      exTemplateStockCustomerList({
        ...this.formDataKH,
        organizationIds: this.CKName.join(','),
        organizationFlag: 1,
        productType: this.productType,
        steelMillName: this.steelMillName,
        specification: this.specification,
        model: this.model,
        firstRequest: '1',
        exportCustomer: this.HZradio,
        organizationName: arr.join(',')
      }).then(res => {
        console.log(res)
        exportExcel(
          this.global.wmsStockName + '/stockThreadExp/exTemplateStockCustomerList', {
            ...this.formDataKH,
            organizationIds: this.CKName.join(','),
            organizationFlag: 1,
            productType: this.productType,
            steelMillName: this.steelMillName,
            specification: this.specification,
            model: this.model,
            exportCustomer: this.HZradio,
            organizationName: arr.join(',')
          },
          '客户库存信息表'
        )
        this.DialogVisible = false
        this.HZradio = 2
      })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    BHQx () {
      this.DialogVisible = false
      this.HZradio = 2
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList({
        organizationFlag: 1
      })
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/kcReport')
    this.chaxun()
    this.getVirtualBalingList()
    this.findUserTenantRelList()
    this.JfgetStockWarehouseLists()
  },
  mounted () {
    let h = this.$refs.searchBoxKH.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 232 + 'px'
  }

}

</script>

<style lang="less" scoped>
  .inpBox1 {
    /deep/ .el-form-item {
      margin-left: 10px;
      margin-bottom: 0px;
    }
  }

</style>
